exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo-ruleForm[data-v-37443012] {\r\n  /* font-size: 0; */\n}\n.backgroundbox[data-v-37443012] {\r\n  display: none;\r\n  z-index: 9999;\r\n  position: fixed;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.backgroundbox .box[data-v-37443012] {\r\n  position: absolute;\r\n  height: 50%;\r\n  width: 50%;\r\n  background-color: #fff;\n}\n.backgroundbox .body[data-v-37443012] {\r\n  margin: 8px;\n}\r\n", ""]);

// exports
